import CustomBendpoint from './bender.js';

export default {
    __init__: [ 'bendpoints' ],
    bendpoints: [ 'type', CustomBendpoint ]
};